module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDialog),
      expression: "showDialog"
    }],
    staticClass: "rtop-dialog-wrap"
  }, [(_vm.daysUse > 0) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt,
      "disabled": _vm.daysUse === 0
    },
    on: {
      "btnClick": function($event) {
        return _vm.topBtnClick()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("使用置顶后您的全职简历将在列表顶端展示，更多HR将会看到您的简历。您剩余置顶天数为："), _c('em', [_vm._v(_vm._s(_vm.daysUse) + "天")])]), _vm._v(" "), _c('div', {
    staticClass: "resume-chose clear"
  }, [_c('p', {
    staticClass: "tit inline fl"
  }, [_vm._v("选择简历：")]), _vm._v(" "), _c('ul', {
    staticClass: "resume-list fl"
  }, _vm._l((_vm.resumeList), function(item, index) {
    return _c('li', {
      key: item.confuseResumeId,
      staticClass: "resume",
      class: {
        checked: _vm.choseIndex === index, 'status-toping': item.resumeTopState
      },
      on: {
        "click": function($event) {
          return _vm.choseResume(index, item.confuseResumeId)
        }
      }
    }, [_vm._v(_vm._s(item.resumeName))])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "tit inline fl"
  }, [_vm._v("置顶天数：")]), _vm._v(" "), _c('ul', {
    staticClass: "days-list fl"
  }, _vm._l((_vm.dayList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "day",
      class: {
        checked: item.daysid === _vm.dayChose, 'unable-day': _vm.daysUse < item.daysid
      },
      on: {
        "click": function($event) {
          return _vm.choseDay(item.daysid)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 0)]) : _c('cvip-alert', {
    attrs: {
      "buttonTxt": "去看看",
      "widthnew": "600px",
      "heightnew": "260px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-close": _vm.closeConfirm,
      "on-confirm": _vm.onConfirm
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("尊贵的会员")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": "2"
    }
  }, [_vm._v("会员套餐中的简历置顶已使用完毕，您可以使用超低的会员价对简历置顶单独购买~")]), _vm._v(" "), _c('p', [_vm._v("(设置方式：我的简历--置顶按钮)")])]), _vm._v(" "), (_vm.showWarn) ? _c('cvip-alert', {
    attrs: {
      "buttonTxt": "我知道了",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-warn"
  }), _vm._v(" "), _c('span', [_vm._v("请选择简历或者置顶天数！")])]) : _vm._e(), _vm._v(" "), (_vm.showCancelWarn) ? _c('cvip-alert', {
    staticClass: "cancel-warn",
    attrs: {
      "cancelBtnTxt": "取消",
      "buttonTxt": "确定",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide,
      "on-confirm": _vm.cancelResumeTop
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-warn"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cancelWarnTipText))])]) : _vm._e(), _vm._v(" "), (_vm.showDayUseWarn) ? _c('cvip-alert', {
    staticClass: "cancel-warn",
    attrs: {
      "cancelBtnTxt": "取消",
      "buttonTxt": "去充值",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide,
      "on-confirm": _vm.goRecharge
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-warn"
  }), _vm._v(" "), _c('span', [_vm._v("您的置顶剩余资源不够")])]) : _vm._e(), _vm._v(" "), _c('toast', {
    staticClass: "cancel-toast",
    attrs: {
      "text": _vm.toastText
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-436439b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/ResumeTopDialog.vue
// module id = xQzT
// module chunks = 1